"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var alasql = require("alasql");
var ButtonDoExportXLS_1 = require("../../../../../../shared/components/buttons/ButtonDoExportXLS");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var RepPromoCodesList = /** @class */ (function (_super) {
    __extends(RepPromoCodesList, _super);
    function RepPromoCodesList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Шаблон промокода',
                dataIndex: _this.props.data.dk_promocode_tpl_title,
                key: _this.props.data.dk_promocode_tpl_title,
                width: 250,
                render: function (text, record, idx) {
                    if (!record.total) {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "gray" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "gift" })),
                            " ",
                            record.promocode_tpl_title));
                    }
                    else {
                        return (React.createElement("div", null,
                            React.createElement("b", null, record.promocode_tpl_title)));
                    }
                }
            }, {
                title: 'Статус',
                dataIndex: _this.props.data.dk_bonus_state_title,
                key: _this.props.data.dk_bonus_state_title,
                width: 150,
            }, {
                title: 'Кол-во',
                dataIndex: _this.props.data.dk_bonus_count,
                key: _this.props.data.dk_bonus_count,
                width: 150,
            }, {
                title: 'Начальная сумма',
                children: [{
                        title: 'Деньги',
                        dataIndex: _this.props.data.dk_creation_money_amount,
                        key: _this.props.data.dk_creation_money_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                record.creation_money_amount.toFixed(2),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }, {
                        title: 'Бонус',
                        dataIndex: _this.props.data.dk_creation_bonus_amount,
                        key: _this.props.data.dk_creation_bonus_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                record.creation_bonus_amount.toFixed(2),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }]
            }, {
                title: 'Финальная сумма',
                children: [{
                        title: 'Итого',
                        dataIndex: _this.props.data.dk_bonus_state_code,
                        key: _this.props.data.dk_bonus_state_code,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                (record.completition_money_amount + record.completition_bonus_amount).toFixed(2),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }, {
                        title: 'Деньги',
                        dataIndex: _this.props.data.dk_completition_money_amount,
                        key: _this.props.data.dk_completition_money_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                record.completition_money_amount.toFixed(2),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }, {
                        title: 'Бонус',
                        dataIndex: _this.props.data.dk_completition_bonus_amount,
                        key: _this.props.data.dk_completition_bonus_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                record.completition_bonus_amount.toFixed(2),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }]
            }
        ];
        return _this;
    }
    RepPromoCodesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data,
                totalRows: data.total_count
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
            selected_currency_id: this.props.state.getCurrencyId()
        }, function () {
            //alert(`${this.props.state.getCurrencyId()} <-> ${this.props.state.getOrgId()}`);
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    RepPromoCodesList.prototype.getDefaultAppCurrencyId = function () {
        if (this.props.availCurrency.length > 0) {
            return this.props.availCurrency[0].key;
        }
        else {
            return 0;
        }
    };
    RepPromoCodesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    RepPromoCodesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    RepPromoCodesList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadData({
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            brands_id_list: this.props.brandsList,
            all_brands: this.props.allBrands,
            app_currency_id: this.state.selected_currency_id,
            allBonusStates: this.props.allBonusStates,
            bonus_states: this.props.bonusStatesList
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    RepPromoCodesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
    };
    RepPromoCodesList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    RepPromoCodesList.prototype.onOfferFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onOfferFilterChanged) {
            this.props.onOfferFilterChanged(allBrands, BrandId, Action);
        }
    };
    RepPromoCodesList.prototype.doExportPlayers = function () {
        var _this = this;
        this.props.dlgExportList
            .clearFields()
            .SetDialogTitle("Экспорт отчета")
            .SetOnYesClick(function (exportFormat) {
            _this.props.data.doExportObjectArray({
                from_year: _this.state.dtFrom.get('year'),
                from_month: _this.state.dtFrom.get('month') + 1,
                from_day: _this.state.dtFrom.get('date'),
                to_year: _this.state.dtTo.get('year'),
                to_month: _this.state.dtTo.get('month') + 1,
                to_day: _this.state.dtTo.get('date'),
                brands_id_list: _this.props.brandsList,
                all_brands: _this.props.allBrands,
                app_currency_id: _this.state.selected_currency_id,
                allBonusStates: _this.props.allBonusStates,
                bonus_states: _this.props.bonusStatesList
            }, function (data) {
                if (exportFormat === "XLSX") {
                    var opts = [{ sheetid: 'Exported report data', header: true }];
                    var result = alasql('SELECT * INTO XLSX("exported_report_data.xlsx",?) FROM ?', [opts, [data]]);
                }
                if (exportFormat === "CSV") {
                    var result = alasql('SELECT * INTO CSV("exported_report_data.csv", {headers:true}) FROM ?', [data]);
                }
                if (exportFormat === "JSON") {
                    var result = alasql('SELECT * INTO JSON("exported_report_data.json", {headers:false}) FROM ?', [data]);
                }
                if (exportFormat === "TXT") {
                    var result = alasql('SELECT * INTO TAB("exported_report_data.txt", {headers:true}) FROM ?', [data]);
                }
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 ",
                    React.createElement("b", null,
                        "[",
                        exportFormat,
                        "]"),
                    " \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D !"));
            });
        }).Show();
    };
    RepPromoCodesList.prototype.getCurrencyISO = function (id) {
        for (var i = 0; i < this.props.availCurrency.length; i++) {
            if (this.props.availCurrency[i].key == id) {
                return this.props.availCurrency[i].value;
            }
        }
        return "";
    };
    RepPromoCodesList.prototype.getCurrencyValue = function () {
        if (this.state.selected_currency_id === 0) {
            return undefined;
        }
        else {
            return {
                key: this.state.selected_currency_id.toString(),
                label: this.getCurrencyISO(this.state.selected_currency_id)
            };
        }
    };
    RepPromoCodesList.prototype.getSelectCurrencyItems = function () {
        var _ret = [];
        for (var i = 0; i < this.props.availCurrency.length; i++) {
            _ret.push(React.createElement(antd_1.Select.Option, { key: "" + i, value: "" + this.props.availCurrency[i].key }, this.props.availCurrency[i].value));
        }
        return _ret;
    };
    RepPromoCodesList.prototype.onCurrencyValueChange = function (value, option) {
        this.setState({
            selected_currency_id: parseInt(value.key)
        });
    };
    RepPromoCodesList.prototype.onDepositTypeFilterChanged = function (allBonusStates, BonusStateCode, Action) {
        if (this.props.onBonusStateFilterChanged) {
            this.props.onBonusStateFilterChanged(allBonusStates, BonusStateCode, Action);
        }
    };
    RepPromoCodesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ButtonDoExportXLS_1.default, { hint: "Экспорт списка", onClick: function () { _this.doExportPlayers(); } }),
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) }),
                React.createElement("div", { style: { marginLeft: "5px", marginRight: "5px", whiteSpace: "nowrap" } }, "\u0412\u0430\u043B\u044E\u0442\u0430 \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u0430"),
                React.createElement(antd_1.Select, { style: { width: "100px", marginLeft: "5px", marginRight: "2px" }, showSearch: true, optionFilterProp: "children", filterOption: function (input, option) {
                        return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                    }, onChange: this.onCurrencyValueChange.bind(this), labelInValue: true, value: this.getCurrencyValue() }, this.getSelectCurrencyItems()),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onOfferFilterChanged.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBonusStates, availBrands: this.props.availBonusSTates, captions: { checkbox: "Все статусы бонусов: ", placeholder: "Выберите статус бонуса" }, selectedBrands: this.props.bonusStatesList, onBrandFilterChanged: this.onDepositTypeFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data.data, pagination: false, rowClassName: function (record) {
                    if (record.total) {
                        return "summary-table-row";
                    }
                    else {
                        return "";
                    }
                }, 
                /*expandedRowRender={
                    (record: IReportByPartnersListItem) => {
                        return (
                            <div>
                                <ReportByPartnersDetailExpander

                                    state={this.props.state}
                                    record={record}
                                    errDialog={this.props.errDialog}
                                    filter={{
                                        from_year: this.state.dtFrom.get('year'),
                                        from_month: this.state.dtFrom.get('month') + 1,
                                        from_day: this.state.dtFrom.get('date'),
                                        to_year: this.state.dtTo.get('year'),
                                        to_month: this.state.dtTo.get('month') + 1,
                                        to_day: this.state.dtTo.get('date'),
                                        offers_id_list: this.props.offersList,
                                        all_offers: this.props.allOffers
                                    }}
                                    dlgExportList={this.props.dlgExportList}
                                />
                            </div>
                        )
                    }
                }*/
                //expandRowByClick={true}
                /*expandIcon={(props)=>{
                    if(props.record.usr_partner_subagents_count > 0) {
                        props.expandable = true;
                        if(props.expanded) {
                            return <span className="ant-table-row-expand-icon ant-table-row-expanded" />//ant-table-row-expanded
                        } else {
                            return <span className="ant-table-row-expand-icon ant-table-row-collapsed" />//ant-table-row-expanded
                        }
                    } else {
                        props.expandable = false;
                        return null;
                    }
                    
                }}*/
                //</div>onExpand={(expanded, record) => {
                //expanded
                //}}
                /*footer={(data: IReportByPartnersListItem[]) => {
                    return <div>Нажмите [+] (если есть) слева от партнера для просмотра данных по субпартнерам</div>;
                }}*/
                scroll: { x: true } })));
    };
    return RepPromoCodesList;
}(React.Component));
exports.default = RepPromoCodesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/rep_promocodes/ui/component/RepPromoCodesList.tsx
// module id = 2537
// module chunks = 0